import React from "react";
import {
  Button,
  CardActions,
  CardContent,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import DineroFactory, { Dinero } from "dinero.js";
import { markPayment } from "../../../../sdk/royalties";
import {
  CardLoading,
  CardLoadingProps,
} from "../../../../components/card-loading";

interface EarningsTotalProps extends CardLoadingProps {
  userId: string;
  email?: string;
  balance?: Dinero;
}

export const EarningsBalance: React.FC<EarningsTotalProps> = ({
  userId,
  email,
  balance,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [payout, setPayout] = React.useState<number>();

  React.useEffect(() => {
    setPayout(balance?.toRoundedUnit(2, "HALF_DOWN") || 0);
  }, [balance]);

  const handleClose = () => setOpen(false);

  const _markPayment = async () => {
    if (!balance || !email || loading || !payout) {
      return;
    }
    setLoading(true);

    await markPayment(userId, {
      email,
      amount: DineroFactory({
        amount: Math.round(payout * 100),
        precision: 2,
        currency: "USD",
      }).toObject(),
    });
    setLoading(false);
    setOpen(false);
    window.location.reload();
  };

  return (
    <CardLoading {...props} style={{ width: "200px", ...props.style }}>
      <CardContent>
        <Typography color="textSecondary" gutterBottom>
          Balance
        </Typography>
        <Typography variant="h5" component="h2">
          {balance?.toFormat() || "$0"}
        </Typography>
        <Typography color="textSecondary">Pending</Typography>
      </CardContent>
      {balance?.greaterThan(
        DineroFactory({ amount: 0, precision: 2, currency: "USD" })
      ) ? (
        <CardActions>
          <Button size="small" onClick={() => setOpen(true)}>
            Pay Balance
          </Button>
        </CardActions>
      ) : null}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Pay Balance</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter the payout amount:</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="amount"
            label="Amount"
            type="number"
            value={payout}
            onChange={(ev) => setPayout(Number(ev.target.value))}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            disabled={!payout || loading}
            onClick={_markPayment}
            color="primary"
          >
            {loading ? <CircularProgress size={24} /> : "Mark Payment"}
          </Button>
        </DialogActions>
      </Dialog>
    </CardLoading>
  );
};
